/**
 *   Routes zeigen weiterhin auf diese Datei.
 *   Hier wird lediglich der Container eingebunden,
 *   der wiederum die View rendert.
 */
import * as React from 'react';
import EditJobsContainer from '../components/edit-jobs-container';

const EditJobs = () => <EditJobsContainer />;

export default EditJobs;
